
export default (state = -1, action) => {
    if (action.type === 'SORT_ORDER') {
        return action.payload;
    }

    return state;
}